import React, { useState } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'



function UserLogin() {


    const [email,setEmail]=useState('')
    const [password,setPassword]=useState('')

    
    const navigate=useNavigate()


   const handleLogin=(e)=>{

    

    e.preventDefault()
    axios.post('https://rahulbloging.onrender.com/loginUser',{
     
     email: email,
     password: password,
    })
    .then((result)=>{
     console.log(result.data)
     localStorage.setItem("token",result.data.token)
     localStorage.setItem("useuserId",result.data.userId)
    //  console.log(localStorage.getItem("useuserId"))
    navigate('/')
     alert("Login SuccessFully")
     
    })
   .catch((err)=>{
     console.log(err)

     alert(err.response.data.msg)
   })


   }










    return (
        <div >
            <div className="container " id='lo'>

                <form>
                    <div class="mb-3">
                        <label for="exampleInputEmail1" class="form-label">Email address</label>
                        <input onChange={(e)=>setEmail(e.target.value)} type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
                        <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div>
                    </div>
                    <div class="mb-3">
                        <label for="exampleInputPassword1" class="form-label">Password</label>
                        <input onChange={(e)=>setPassword(e.target.value)} type="password" class="form-control" id="exampleInputPassword1" />
                    </div>
                   
                    <button onClick={handleLogin}  type="submit" class="btn btn-primary m-4">Submit</button>
                </form>


            </div>

        </div>
    )
}

export default UserLogin
